// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink, Navigate } from 'react-router-dom';
import './styles/main.css';
import './styles/form.css';  
import './styles/modal.css';   
import './styles/Table.css';  
import SimList from './components/SimList';
import Personnel from './components/Personnel'; 
import Login from './components/Login';
import GenericPortalLogins from './components/GenericPortalLogins'; // Import the new view

function App() {
  const hostname = window.location.hostname;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1';

  // --- LOCAL BYPASS INITIALIZATION ---
  const [isAuthenticated, setIsAuthenticated] = useState(isLocal ? true : false);
  const [isLoading, setIsLoading] = useState(isLocal ? false : true);

  // Determine auth service URL dynamically
  const getAuthServiceURL = () => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:4001';
    }
    return `https://auth.${hostname.split('.').slice(-3).join('.')}`;
  };

  useEffect(() => {
    if (isLocal) {
      console.log('SSO locally bypassed: Welcome to offline development.');
      return;
    }

    const AUTH_SERVICE_URL = getAuthServiceURL();
    
    // Check for real SSO authentication (Production)
    fetch(`${AUTH_SERVICE_URL}/auth/me`, { 
      credentials: 'include' 
    })
    .then(r => r.ok ? r.json() : Promise.reject())
    .then(user => {
      setIsAuthenticated(true);
      console.log('SSO authenticated:', user);
    })
    .catch(() => {
      setIsAuthenticated(false);
    })
    .finally(() => setIsLoading(false));
  }, [isLocal]);

  const handleLogout = async () => {
    const AUTH_SERVICE_URL = getAuthServiceURL();
    await fetch(`${AUTH_SERVICE_URL}/auth/logout`, {
      method: 'POST',
      credentials: 'include'
    }).catch(() => {});
    
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return <div style={{ textAlign: 'center', marginTop: '50px' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Login setAuth={setIsAuthenticated} />;
  }

  return (
    <Router>
      <div className="app-container">
        <header className="app-header">
          <h1>Device & Password Management</h1>
          
          {/* Main Navigation remains centered */}
          <nav className="main-nav">
            <NavLink 
              to="/" 
              className={({ isActive }) => isActive ? "active" : ""}
            >
              SIMs
            </NavLink>
            <NavLink 
              to="/personnel"
              className={({ isActive }) => isActive ? "active" : ""}
            >
              MyBrandz
            </NavLink>
          </nav>

          {/* New Portal Views mapped as Right-Side Navigation buttons */}
          <div className="header-actions">
            <NavLink 
              to="/enews" 
              className="nav-external-btn"
            >
              E-News
            </NavLink>
            <NavLink 
              to="/artwork-portal" 
              className="nav-external-btn"
            >
              Artwork Portal
            </NavLink>
            <button onClick={handleLogout} className="btn btn-cancel">
              Logout
            </button>
          </div>
        </header>
        
        <div className="main-content">
          <Routes>
            <Route path="/" element={<SimList />} />
            <Route path="/personnel" element={<Personnel />} />
            
            {/* Added Portal Routes utilizing the dynamic view component */}
            <Route 
              path="/enews" 
              element={<GenericPortalLogins portalType="enews" title="E-News Logins" />} 
            />
            <Route 
              path="/artwork-portal" 
              element={<GenericPortalLogins portalType="artwork" title="Artwork Portal Logins" />} 
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
